import React, { Component } from 'react';
import { Form, Input, Button, Row, Col, Alert, message } from 'antd';
import { connect } from 'react-redux';
import * as actions from '../redux/actions/products';

class CreateProduct extends Component {
    formRef = React.createRef();
    layout = {
        labelCol: {
            span: 8,
        },
        wrapperCol: {
            span: 16,
        },
    };
    tailLayout = {
        wrapperCol: {
            offset: 8,
            span: 16,
        },
    };

    onFinish = async (values) => {
        await this.props.onCreate(values.name, this.props.token);
        if(this.props.message){
            message.success(this.props.message);
        }
        if(this.props.error){
            message.error(this.props.error);
        }
        this.formRef.current.resetFields();
    };

    onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
  
    render() {
        return (
            <Row justify="left" align="middle">
                <Col lg={8} sm={20}>
                    <Form
                        {...this.layout}
                        name="basic"
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                        ref={this.formRef}
                    >
                        <Form.Item
                            label="Product Name"
                            name="name"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your name!',
                                },
                                { min: 4, message: 'Name must be minimum 4 characters.' },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item {...this.tailLayout}>
                            <Button type="primary" htmlType="submit">
                                Create
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        );
    }

};
const mapStateToProps = state => {
    return {
        token: state.auth.token,
        error: state.products.error,
        message:state.products.message,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onCreate: (name, token) => dispatch(actions.createProduct(name,token)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CreateProduct);